import { render, staticRenderFns } from "./CreateRoutingRuleModal.vue?vue&type=template&id=1d21cf94"
import script from "./CreateRoutingRuleModal.vue?vue&type=script&lang=js"
export * from "./CreateRoutingRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports